import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, ViewChild } from '@angular/core';
import { CdkTree } from '@angular/cdk/tree';

import { OutletDirective } from '../../directives/outlet.directive';

@Component({
  selector: 'mcrai-tree',
  template: `<ng-container mcraiTreeNodeOutlet></ng-container>`,
  styles: [`.mcrai-tree-node{display:flex;align-items:center;margin-bottom:2px}`],
  encapsulation: ViewEncapsulation.None,
  preserveWhitespaces: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [{ provide: CdkTree, useExisting: TreeComponent }],
  host: {
    'class': 'mcrai-tree'
  },
})
export class TreeComponent<T> extends CdkTree<T> {

  @ViewChild(OutletDirective) _nodeOutlet: OutletDirective;

}